var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomerPromise(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.932 1.73a9.22 9.22 0 016.347 2.523l-2.62-.074-.021.655 2.99.083c.087 0 .17-.035.231-.096a.358.358 0 00.096-.24l-.087-3.187h-.655l.053 1.956A9.93 9.93 0 002.459 16.179l.559-.34a9.28 9.28 0 017.914-14.126v.017zM19.549 5.799l-.559.344A9.276 9.276 0 014.724 17.746l2.62.074v-.654l-2.96-.079a.337.337 0 00-.315.206.305.305 0 00-.021.13l.087 3.187h.655l-.057-1.956A9.936 9.936 0 0019.544 5.82l.005-.021z",
    fill: "#000",
    stroke: "#000",
    strokeWidth: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.058 7.676a.323.323 0 00-.327.327v.974l-5.675 3.265a.323.323 0 00-.161.284v1.65a.576.576 0 00.576.576h11.022a.577.577 0 00.576-.576v-1.65a.331.331 0 00-.161-.284l-5.535-3.265v-.681a1.562 1.562 0 10-1.89-1.528h.654a.909.909 0 11.908.908h.013zm0 1.868l4.5 2.654H6.463l4.596-2.654zm-5.491 4.553v-1.244h10.865v1.244H5.567z",
    fill: "#000",
    stroke: "#000",
    strokeWidth: 0.29
  })));
}
export default SvgCustomerPromise;